import { FC, useEffect, useState } from "react";
import { CheckListItem } from "../../../types/CheckListItem";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  EditEventArgs,
  EditSettingsModel,
  Grid,
  GridComponent,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { Col, Container, Row } from "react-grid-system";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";

interface IDisplayCheckListModal {
  open: boolean;
  checkListName: string;
  jobNumber: string;
  onUpdateNote: (jobNumber: string, note: string) => void;
  onClose: () => void;
  checkListItems: CheckListItem[];
}

export const DisplayCheckListModal: FC<IDisplayCheckListModal> = ({
  open,
  onUpdateNote,
  onClose,
  checkListName,
  checkListItems,
  jobNumber,
}) => {
  const [items, setItems] = useState<CheckListItem[]>([]);
  const [errors, setErrors] = useState("");

  useEffect(() => {
    setItems(checkListItems);
    if (items) {
      validate(items);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buttons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
        disabled: errors && errors.length > 0 ? true : false,
      },
      click: () => {
        const notes = items
          .map((item) => {
            return `CheckList item ${item.description} set ${
              item.checked === true ? "Checked" : "N/A"
            }`;
          })
          .join("\\n");
        onUpdateNote(jobNumber, notes);
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 600, Y: 200 };

  let grid: Grid | null;

  /* const load = (): void => {
    let instance = (document.getElementById("GridCheckList") as any)
      .ej2_instances[0]; //(document.('GridCheckList') as HTMLElement).ej2_instances[0];
    console.log(`loading ${grid} ${instance}`);
    if (instance) {
      instance.element.addEventListener("mouseup", function (e: any) {
        if ((e.target as HTMLElement).classList.contains("e-rowcell")) {
          if (instance.isEdit) instance.endEdit();
          let index: number = parseInt(
            (e.target as HTMLElement).getAttribute("Index") ?? ""
          );
          instance.selectRow(index);
          instance.startEdit();
        }
      });
    }
  };

  const onActionComplete = (args: EditEventArgs) => {
    console.log(`onActionComplete ${args.requestType}`);
    if (args.requestType === "refresh" || args.requestType === "save") {
      validate(items);
    }
  }; */

  const validate = (checkListItems: CheckListItem[] | undefined) => {
    console.log(`onValidate  ${JSON.stringify(checkListItems)}`);
    if (items?.some((item) => !item.checked && !item.notApplicable)) {
      setErrors("Please enter all checklist items.");
    } else {
      setErrors("");
    }
  };

  const conditionCheckedTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          id="checkTest"
          checked={props.checked}
          onChange={(args: any) => {
            const updatedItems = [
              ...items.map((item) => {
                if (item.description === props.description) {
                  item.checked = args.target.checked;
                  item.notApplicable = !args.target.checked;
                }
                return item;
              }),
            ];
            console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
            validate(updatedItems);
            setItems(updatedItems);
          }}
        />
      </div>
    );
  };

  const conditionNotApplicableTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          id="notApplicableTest"
          checked={props.notApplicable}
          onChange={(args: any) => {
            const updatedItems = [
              ...items.map((item) => {
                if (item.description === props.description) {
                  item.notApplicable = args.target.checked;
                  item.checked = !args.target.checked;
                }
                return item;
              }),
            ];
            console.log(`onclicked  ${JSON.stringify(updatedItems)}`);
            validate(updatedItems);
            setItems(updatedItems);
          }}
        />
      </div>
    );
  };

  const editSettings: EditSettingsModel = {
    allowEditing: true,
    allowAdding: false,
    allowDeleting: false,
    mode: "Normal",
  };

  return (
    <DialogComponent
      width="600px"
      close={onClose}
      header={`Check List: ${checkListName}`}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <GridComponent
              dataSource={items}
              id="GridCheckList"
              //allowPaging={true}
              allowTextWrap={true}
              //allowResizing={true}
              gridLines="Both"
              ref={(g: GridComponent) => (grid = g)}
              //editSettings={editSettings}
              //load={load}
              //actionComplete={onActionComplete}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="description"
                  headerText="Description"
                  type="string"
                  isPrimaryKey={true}
                />
                {/*  <ColumnDirective
                  field="checked"
                  headerText="Yes"
                  width="70"
                  editType="booleanedit"
                  allowEditing={true}
                />
                <ColumnDirective
                  field="notApplicable"
                  headerText="N/A"
                  width="70"
                  editType="booleanedit"
                  allowEditing={true}
                /> */}
                <ColumnDirective
                  field="checked"
                  headerText="Yes"
                  width="60"
                  type="boolean"
                  template={conditionCheckedTemplate}
                />
                <ColumnDirective
                  field="notApplicable"
                  headerText="N/A"
                  width="60"
                  type="boolean"
                  template={conditionNotApplicableTemplate}
                />
              </ColumnsDirective>
              <Inject services={[Edit, Resize]} />
            </GridComponent>
          </Row>
          <Row align="stretch">
            <h6 style={{ color: "red" }}>{errors}</h6>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
